import { ConversationStatus } from 'generated-graphql/types';

export const conversationStatusesForRejectedAutomationAction = [
  ConversationStatus.CompletedRejected,
  ConversationStatus.CompletedNotInterested,
  ConversationStatus.Completed,
  ConversationStatus.OptedOut
];

export const validateStatusIsRejectionAction = (
  status: ConversationStatus | null | undefined
) => {
  if (!status) {
    return false;
  }

  return conversationStatusesForRejectedAutomationAction.includes(status);
};
